import { useHistory, useLocation } from "react-router-dom";
import images from "../../utilities/images/images";
import successTick from "./assets/mb-success-tick.png";
import "./MistakeBookSuccessPage.css";

const MistakeBookSuccessPage = () => {
  const history = useHistory();
  const location = useLocation();
  const state = location.state || {};

  const subjectListingState = {
    year: state.year,
    subjectId: state.subjectId || state.subject?.id,
    subjectName: state.subjectName || state.subject?.name || "",
    subject: state.subject,
  };

  const handleHeaderBack = () => {
    if (history.length > 1) {
      history.goBack();
      return;
    }
    history.push(
      state.listPath || "/practice/mistake-book/topic-questions",
      state.listState || subjectListingState
    );
  };

  const handleGoToMistakeBook = () => {
    history.push("/practice/mistake-book", subjectListingState);
  };

  return (
    <div className="mb-success-page">
      <header className="mb-success-header">
        <button
          type="button"
          className="mb-success-header__back"
          onClick={handleHeaderBack}
          aria-label="Go back"
        >
          <img src={images.new_backarrow} alt="" />
        </button>
        <h1 className="mb-success-header__title">Mistake Book</h1>
        <div className="mb-success-header__spacer" aria-hidden="true" />
      </header>

      <div className="mb-success-body">
        <div className="mb-success-content">
          <div className="mb-success-hero">
            <div className="mb-success-icon" aria-hidden="true">
              <img src={successTick} alt="" />
            </div>
            <div className="mb-success-copy">
              <h2 className="mb-success-copy__title">
                Added to Mistake Book Successfully
              </h2>
              <p className="mb-success-copy__description">
                All Your incorrect questions have been successfully added to the
                Mistake Book for revision.
              </p>
            </div>
          </div>

          <div className="mb-success-actions">
            <button
              type="button"
              className="mb-success-btn mb-success-btn--primary"
              onClick={handleGoToMistakeBook}
            >
              Go to Mistake Book
            </button>
            <button
              type="button"
              className="mb-success-btn mb-success-btn--secondary"
              onClick={handleHeaderBack}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MistakeBookSuccessPage;
